import Model from './Model'

export default class CustomerModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'customers'
  }
}
